import React from 'react';
import PropTypes from 'prop-types';

const IconMeatBallMenu = ({ width = 16, height = 16, viewBox = '0 0 16 16' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill='none'>
        <path d='M4 6V10H0V6H4ZM10 6V10H6V6H10ZM16 6V10H12V6H16Z' fill='#1F1F1F' />
    </svg>;
};

IconMeatBallMenu.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    viewBox: PropTypes.string
};
export default IconMeatBallMenu;
